import {
  RootDiv,
  CartProductCartActionsIconButton,
  CartProductCartActionsTypography,
} from './ProductQuantityActions.styles';

import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useCallback } from 'react';

interface ProductQuantityActionsProps {
  quantity: number;
  MAX_AMOUNT: number;
  addQuantity: () => void;
  subQuantity?: () => void;
  loading?: boolean;
}

export function ProductQuantityActions({
  quantity,
  addQuantity,
  subQuantity,
  MAX_AMOUNT,
  loading,
}: ProductQuantityActionsProps) {
  const handleAddQuantity = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (loading) return;
      addQuantity();
      event.stopPropagation();
      event.preventDefault();
    },
    [addQuantity, loading],
  );

  const disabled = loading || quantity >= MAX_AMOUNT;

  return (
    <RootDiv onClick={(event) => event.stopPropagation()}>
      {subQuantity && quantity > 0 && (
        <>
          <CartProductCartActionsIconButton
            style={quantity <= 1 ? { border: 'none' } : {}}
            onClick={(event) => {
              subQuantity();
              event.stopPropagation();
            }}
          >
            {quantity <= 1 ? <DeleteIcon /> : <RemoveIcon />}
          </CartProductCartActionsIconButton>
          <CartProductCartActionsTypography>
            {quantity}
          </CartProductCartActionsTypography>
        </>
      )}
      <CartProductCartActionsIconButton
        onClick={handleAddQuantity}
        disabled={disabled}
      >
        <AddIcon />
      </CartProductCartActionsIconButton>
    </RootDiv>
  );
}
